<template>
  <div
    class="bbp-select-list"
    :style="popupPosition"
  >
    <div
      class="bbp-select-list-item"
      v-for="(item, index) in items"
      :key="item[settings.key]"
      :style="{color: `rgba(${item[settings.color]}, 1)`}"
      @click.stop="onActive(item)"
    >
      <div
        class="bbp-select-list-item__counter"
        :style="{background: `rgba(${item[settings.color]}, 0.15)`}"
      >
        {{index + 1}}
      </div>
      <div class="bbp-select-list-item__text">
        {{item[settings.value]}}
      </div>
      <div
        v-if="item[settings.isActive] === isActive"
        class="bbp-select-list-item__icon"
        v-html="okIcon"
      />
    </div>
  </div>
</template>

<script>
import { OK_ICON } from '@/constants/icons'

export default {
  name: 'BBPSelectList',
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    popupPosition: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    okIcon: OK_ICON()
  }),
  methods: {
    onActive (item) {
      this.$emit('onActive', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

  .bbp-select-list {
    min-width: 258px;
    max-height: 116px;
    overflow: scroll;
    padding: 16px 16px 16px 16px;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    z-index: 10;

    &::-webkit-scrollbar {
      width: 4px;
      height: 0;
      background-color: $color-white;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-denim;
      border-radius: 5px;
    }
  }

  .bbp-select-list-item {
    display: flex;
    align-items: center;
    grid-gap: 0 8px;

    & + & {
      margin: 16px 0 0 0;
    }

    &__counter {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-size: 10px;
      line-height: 13px;
      font-weight: 600;
      white-space: nowrap;
      height: 17px;
      width: 17px;
    }

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }

    &__icon {
      display: flex;
      margin: 0 0 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPSelectList/BBPSelectList.vue